import type { MarketProgram } from '@/openapi/v1/msa-portfolio-manager'

// Placeholder colors - easy to change based on design system
export const MARKET_PROGRAM_COLORS: Partial<Record<MarketProgram, string>> = {
  MFRR_UP: '#00AA00',
  MFRR_DOWN: '#88EE88',
  AFRR_UP: '#0066CC',
  AFRR_DOWN: '#6699FF',
  FCRD_UP: '#FF6600',
  FCRD_DOWN: '#FFAA66',
  FCRN: '#9933CC', // Symmetric market
  NORDICS_FCRN: '#CC66FF',
  NORDICS_FCRD_UP_STATIC: '#FF8800',
  NORDICS_FCRD_UP_DYNAMIC: '#FFAA00',
  NORDICS_FCRD_DOWN_STATIC: '#FFCC88',
  NORDICS_FCRD_DOWN_DYNAMIC: '#FFDD99',
  FFR_UP: '#DD2200',
  MFRRDA_UP: '#00DD00',
  MFRRDA_DOWN: '#99FF99',
  WHOLESALE_SELL: '#00a9dd',
  WHOLESALE_BUY: '#99d5ff',
}

const DEFAULT_COLOR = '#999999'

export function getMarketProgramColor(program: MarketProgram | undefined): string {
  if (!program) return DEFAULT_COLOR
  return MARKET_PROGRAM_COLORS[program] ?? DEFAULT_COLOR
}
